const getRouterConfig = () => {
  const routes = require('../config/router/global.json');
  return routes.reduce((pre, { page, needToken = false, fallbackUrl }) => {
    pre[page.replace(/^\/?/, '/')] = {
      needToken,
      fallbackUrl,
    };
    return pre;
  }, {});
};
const GLOBAL_ROUTE_CONFIG = getRouterConfig();
const USERCENTER_REGRX = /^\/usercenter/;
const LOGIN_REGISTER_URLS = ['/login', '/register'];
const checkLogin = (pathName) => {
  const { needToken, fallbackUrl } = GLOBAL_ROUTE_CONFIG[pathName] || {};
  const redirect = needToken || USERCENTER_REGRX.test(pathName);
  return {
    redirect,
    fallbackUrl,
  };
};

const handleAuth = ({
  req, res, route, query, loginUrl,
}) => {
  const { url, cookies: { logined } } = req;
  const { page } = route;
  const { locale } = query;
  let redirected = false;
  if (logined !== 'y') {
    const { redirect, fallbackUrl = url } = checkLogin(page);
    if (redirect) {
      redirected = true;
      res.redirect(`${loginUrl.replace('%locale', locale)}?callback=${fallbackUrl.replace('%locale', locale)}`);
    }
  } else if (LOGIN_REGISTER_URLS.includes(page)) {
    redirected = true;
    res.redirect(`/${locale}/usercenter/dashboard/overview`);
  }
  return redirected;
};

module.exports = {
  checkLogin,
  handleAuth,
};
